import { lazy } from 'react';

const Login = lazy(() => import('../Sections/Login/login'));
const Home = lazy(() => import('../Sections/Home/index'));
const GetDocument = lazy(() => import('../Sections/Dispensation/GetDocument/index'));
const ChangeStatus = lazy(() => import('../Sections/ChangeStatus/index'));

export default [
  {
    path: '/',
    name: 'Receta Médica Electronica',
    component: Login,
    exact: true,
  },
  {
    path: '/home',
    name: 'Dispensación Receta Médica Electronica',
    component: Home,
    exact: true,
  },
  {
    path: '/changes_status/:id',
    name: 'Receta Médica Electronica',
    component: ChangeStatus,
    exact: true,
  },
  {
    path: '/:dispensation?/:id',
    name: 'Receta Médica Electronica',
    component: GetDocument,
    exact: true,
  },
];
